import { PublicRetrievalStatus } from '@/entities/user-document';
import styles from './public-retrieval-badge.module.scss';

const STATUS_LABELS: Record<Exclude<PublicRetrievalStatus, 'none'>, string> = {
	active: 'Descarga pública activa',
	withdrawn: 'Descarga retirada',
};

// Renders nothing for documents that never had public retrieval, so the column
// stays quiet for the common case.
export const PublicRetrievalBadge = ({
	status,
}: {
	status: PublicRetrievalStatus;
}) => {
	if (status === 'none') {
		return null;
	}

	return (
		<span
			className={[styles.badge, styles[status]].join(' ')}
			data-testid={`public-retrieval-badge-${status}`}
		>
			{STATUS_LABELS[status]}
		</span>
	);
};
